import React from 'react';
import { usePortletTranslations } from 'js/components/system/Portlet';
import style from './index.scss';

export default () => {
    const t = usePortletTranslations();

    return (
        <div className={`${style.table} ${style.empty}`}>
            <div className={style.emptyText}>{t('competitorsTable.empty')}</div>
        </div>
    );
};
